import axiosInstance from "./axiosInstance";

export const trackShipment = async (awb) => {
  try {
    const response = await axiosInstance.get(`/shipping/track/${awb}`);
    console.log(response.data);

    return {
      tracking: response.data.tracking,
      order: response.data.order,
    };
  } catch (error) {
    console.error("Error tracking shipment:", error);
    throw error;
  }
};
